<template>
<Dialog header="Soru Seçeneklerini toplu Yükleyin" 
v-model:visible="show" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
>


<FileUpload   accept=".xlsx, .xls, .csv" @select="onFilesAdded"  @remove="onFilesRemove"   v-model="files" :multiple="false" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin" :fileLimit="1"   :maxFileSize="1000000" class="">
  <template #empty>
      <p>Dosyayı sürükleyip bırakın</p>
  </template>
</FileUpload>

<div class="flex align-items-center justify-content-center mt-3 mb-3" v-if="ready_to_upload">
<h3 class="text-primary ">{{list.length}} adet seçenek yüklenmeye hazır</h3>
</div>


<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="$store.state.ui.submitting"/>
</template>
</Dialog>	
</template>

<script>
const columns_arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","AA"];
import * as XLSX from 'xlsx'
export default {

  name: 'OptionUploadModal',

  data () {
    return {
    	has_error:false,
    	submitting:false,
    	list:[],
    	show:false,
    	files:[],
		ready_to_upload:false,
		current_row:0,
		current_column:0,
		worksheet:null,
    }
  },
  methods:{
  	 onFilesAdded(event)
    {
     console.log(event);
     this.handleXml(event.files[0])
      
      
    },
    onFilesRemove(event)
    {
    	this.ready_to_upload = false
		this.current_column = 0
		this.current_row=2
		this.worksheet = null
		this.list = []

    },
  	showModal()
  	{
  		this.show = true
  	},
  	close()
  	{
  		this.show = false
  		this.ready_to_upload = false
		this.current_column = 0
		this.current_row=2
		this.worksheet = null
		this.list = []
  	},
  	handleXml(f)
    {    	
    	let reader = new FileReader()

    	reader.onload = (e)=>{
    		let data = new Uint8Array(e.target.result)
    		let workbook = XLSX.read(data, {type: 'array'});
    		let current_sheet = workbook.SheetNames[0]; 
    		this.worksheet = workbook.Sheets[current_sheet]; 		
			let current_cell_value =this.getCurrentCellValue()
			this.readOptionLine()
    	}
    	reader.readAsArrayBuffer(f);
    },
    getCurrentCellValue()
	{
		let current_cell_address = columns_arr[this.current_column]+this.current_row;				
		let current_cell = this.worksheet[current_cell_address];
		let current_cell_value = (current_cell ? current_cell.v : undefined);
		if(current_cell_value==undefined)
		{
			current_cell_value = ""
		}
		return current_cell_value;

	},
    async readOptionLine()
  	{
		this.current_row += await 1;
		this.current_column = await 0
		let bus_obj =  await {};
		let the_name =  await this.getCurrentCellValue()
		if(the_name)
		{
			bus_obj.name =  await the_name

			this.current_column +=  await 1
			let the_data =  await this.getCurrentCellValue()
			bus_obj.points =  await the_data	
			

			
			this.list.push(bus_obj)
			await this.readOptionLine()
			
		}
		else
		{
			await console.log(this.list)
			this.ready_to_upload = true
				
			//await this.submitAllSuppliers()
			//this.uploadProcess = await "done"
			//this.current_column = await 0
			//this.current_row = await 1
			return  await false
		}
	},
	submit()
	{

		let formdata = new FormData()
		console.log(this.list)
		//return false
		formdata.append("options",JSON.stringify(this.list))
		console.log(this.list);
		console.log(this.$route.params.id);
		//return false
		this.generalSubmission(formdata,"questionlists/inputfield/options/batch_store/"+this.$route.params.id,this.aftersubmit)

	},
	aftersubmit(response)
	{
		console.log(response.data);
		this.$store.dispatch('suppliers/setSuppliersRenewed',true) 
		this.$emit("uploadCompeted")
		this.close()
	},
  }
}
</script>

<style lang="css" scoped>
</style>